import React from 'react';
import Head from 'next/head';
import { COLORS } from 'Components/utils/color/colors';
import { ICONS } from 'Components/utils/icon/icons';
import { TRACK_PAGE_NAMES } from 'Tracking/constants';
import { TrackPage } from 'Tracking/track-page/TrackPage';
import { Icon } from 'Components/frameworks/icon/Icon';
import { theme } from 'Root/tailwind.config';
type Props = {
  error: InternalServerError;
};
const STYLES = {
  MAIN: {
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    color: 'white',
    fontFamily: theme.fontFamily.sans,
    minHeight: '100vh',
  },
  CONTAINER: {
    margin: 'auto',
    maxWidth: '76.25rem',
  },
  HEADER: {
    alignItems: 'center',
    display: 'flex',
    flexWrap: 'wrap',
    height: '11rem',
    justifyContent: 'space-between',
    padding: '1rem',
  },
  HEADING: {
    margin: 0,
    maxWidth: 320,
    width: '11rem',
  },
  ASIDE: {
    padding: '0 1rem',
    textAlign: 'right',
  },
  CONTACT: {
    margin: 0,
    padding: 0,
  },
  CONTENT: {
    backgroundImage: 'radial-gradient(closest-side,rgba(0,0,0,.2),transparent)',
    maxWidth: '73.75rem',
    textShadow: '0 0 1rem rgba(0,0,0,.4)',
  },
  TITLE: {
    fontFamily: theme.fontFamily.brand,
    fontSize: 'calc(2vw + 10px)',
    margin: '0 0 1rem',
    textAlign: 'right',
  },
  MESSAGE: {
    fontSize: 'calc(2vw + 5px)',
    textAlign: 'right',
  },
  LINK: {
    color: 'white',
    fontWeight: 'bold',
  },
};

const InternalServerErrorView = ({ error }: Props) => (
  <main style={{ ...STYLES.MAIN, backgroundImage: `url(${error.backgroundImage})` }} role="main">
    <TrackPage pageName={TRACK_PAGE_NAMES.ERROR_500} />
    <Head>
      <title>{error.pageTitle}</title>
    </Head>

    <div style={STYLES.CONTAINER}>
      <div style={STYLES.HEADER}>
        <h1 style={STYLES.HEADING}>
          <Icon
            alt="ClubMed"
            isNotSquare
            name={ICONS.CLUBMED}
            style={{
              color: COLORS.WHITE,
            }}
            width="11rem"
          />
        </h1>

        <div style={STYLES.ASIDE}>
          <p style={STYLES.CONTACT}>{error.travelAdvisor}</p>
          <p style={STYLES.CONTACT}>{error.phone}</p>
        </div>
      </div>

      <div style={STYLES.CONTENT}>
        <p style={STYLES.TITLE}>{error.title}</p>
        <div style={STYLES.MESSAGE}>
          {error.callUs}
          &nbsp;
          <a
            data-testid="InternalServerError-phoneLink"
            href={`tel:${error.phone}`}
            style={STYLES.LINK}
          >
            {error.phone}
          </a>
        </div>
      </div>
    </div>
  </main>
);

InternalServerErrorView.pageId = 'InternalError';
InternalServerErrorView.disableHeader = true;
InternalServerErrorView.disableFooter = true;
export default InternalServerErrorView;
